import React, { FC, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';

import ForgotPassword from '@portal/common/components/ForgotPassword';
import {
    WithGoogleAnalyticsInjectedProps,
    withGoogleAnalytics,
} from '@portal/common/services/google-analytics';

import api from '../../api';
import _ from '../../locale';
import { SIGN_IN_PATH } from '../../router/paths';

const ForgotPasswordScene: FC = () => {
    const navigate = useNavigate();
    const handleNext = useCallback(() => {
        navigate(SIGN_IN_PATH, {
            state: { successMessages: [_('forgot_password_success_reset')] },
        });
    }, [history]);

    return (
        <ForgotPassword resetPassword={api.organizationMember.resetPassword} onNext={handleNext} />
    );
};

export default withGoogleAnalytics({
    trackMethods: (props: WithGoogleAnalyticsInjectedProps) => ({
        onResetPassword: () =>
            props.trackEvent({
                category: 'Account',
                action: 'Reset Password',
            }),
    }),
})(ForgotPasswordScene);
